import { InjectionToken } from '@angular/core';

export const PAGE_TITLE = new InjectionToken<string>('PAGE_TITLE');
